import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StringUtil } from '@univacity/shared/util';
import { Menu } from '../../interfaces/menu';

@Component({
  selector: 'un-footer-nav',
  templateUrl: './footer-nav.component.html',
  styleUrls: ['./footer-nav.component.less'],
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNavComponent {
  @Input() heading: string;
  @Input() menus: Menu[] = [];

  // prefixMenu(type: 'tel' | 'email' | 'link'): string {
  //   switch (type) {
  //     case 'tel':
  //       return 'tel:';
  //     case 'email':
  //       return 'mailto:';
  //     default:
  //       return '';
  //   }
  // }

  isExternalUrl(url?: string | string[]) {
    return StringUtil.isExternalUrl(url);
  }
}
